<template>
  <v-row no-gutters>
    <v-col class="d-flex flex-wrap mb-4" cols="12">
      <div>
        <v-hover v-slot="{ hover }">
          <v-card
            :elevation="hover ? 14 : 8"
            class="ma-2 pa-3 rounded-lg d-flex align-center justify-center pattern"
            :class="{ selected: selectedDesign === '' }"
            height="60"
            width="60"
            @click="chooseDesign('')"
          >
            <v-icon color="#222" size="32">mdi-cancel</v-icon>
          </v-card>
        </v-hover>
      </div>
      <div v-for="(item, index) in designObject" :key="index">
        <v-hover v-slot="{ hover }">
          <v-card
            :elevation="hover ? 14 : 8"
            class="ma-2 pa-3 rounded-lg d-flex align-center justify-center pattern"
            height="60"
            :class="{ selected: selectedDesign === item.value }"
            width="60"
            @click="chooseDesign(item.value)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              :class="{ filterwhite: selectedDesign === item.value }"
              class="rounded-0 pattern"
              viewBox="0 0 6 6"
              width="40"
              height="40"
              fill="currentColor"
              v-html="item.img.path"
            ></svg>
          </v-card>
        </v-hover>
      </div>
    </v-col>

    <!-- Eyes Color Control -->

    <v-col class="pa-2" cols="12">
      <v-card class="pa-3 marker-color-section" outlined>
        <div class="text-subtitle-2 mb-3 marker-corner-title">
          <v-icon class="mr-2" color="info">mdi-eye</v-icon>
          {{ $t("eye_colors") }}
        </div>

        <!-- Switch for different eye colors -->
        <v-row no-gutters class="mb-3">
          <v-col cols="12">
            <v-switch
              v-model="options.different_eyes_color"
              :label="$t('separate_colors_for_each_eye')"
              color="primary"
              @change="handleDifferentEyesChange"
            />
            <!-- Debug info -->
            <div class="text-caption grey--text mt-1">
              {{ $t("current_mode") }}
              {{
                options.different_eyes_color
                  ? $t("separate_colors")
                  : $t("same_color")
              }}
            </div>
          </v-col>
        </v-row>

        <!-- Single Eye Color Mode -->
        <v-row v-if="!options.different_eyes_color" no-gutters>
          <v-col cols="12" md="6" class="pa-1">
            <color-picker
              v-model="options.cornersDotOptions.color"
              :label="$t('all_eyes_color')"
              @input="$emit('update', true)"
            />
          </v-col>
        </v-row>

        <!-- Individual Eye Colors Mode -->
        <v-row v-if="options.different_eyes_color" no-gutters>
          <v-col cols="12" md="4" class="pa-1">
            <color-picker
              v-model="options.marker_top_right_center"
              :label="$t('top_right_eye')"
              @input="$emit('update', true)"
            />
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <color-picker
              v-model="options.marker_in_color"
              :label="$t('top_left_eye')"
              @input="$emit('update', true)"
            />
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <color-picker
              v-model="options.marker_bottom_left_center"
              :label="$t('bottom_left_eye')"
              @input="$emit('update', true)"
            />
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker";

export default {
  name: "qrCodeEyeAdv",

  components: { ColorPicker },

  props: {
    value: Object,
    designObject: Array,
  },

  data: () => ({
    selectedDesign: null,
    // bgSwitch: false, // Disabled - eyes only support single colors
    // designObject: [
    //   { value: "square", img: "/media/eye/square.svg" },
    //   { value: "dot", img: "/media/eye/circle.svg" },
    //   { value: "circle", img: "/media/eye/circle.svg" },
    //   { value: "cross", img: "/media/eye/cross.svg" },
    //   { value: "danger", img: "/media/eye/danger.svg" },
    //   { value: "diamond", img: "/media/eye/diamond.svg" },
    //   { value: "drop", img: "/media/eye/drop.svg" },
    //   { value: "dropeye", img: "/media/eye/dropeye.svg" },
    //   { value: "drop_in", img: "/media/eye/drop_in.svg" },
    //   { value: "flurry", img: "/media/eye/flurry.svg" },
    //   { value: "heart", img: "/media/eye/heart.svg" },
    //   { value: "plus", img: "/media/eye/plus.svg" },
    //   { value: "rounded", img: "/media/eye/rounded.svg" },
    //   { value: "sdoz", img: "/media/eye/sdoz.svg" },
    //   { value: "star", img: "/media/eye/star.svg" },
    //   { value: "sun", img: "/media/eye/sun.svg" },
    // ],
    // rotations: 0, // Disabled - eyes only support single colors
  }),

  mounted() {
    // Initialize eye color properties if they don't exist
    if (typeof this.options.different_eyes_color === "undefined") {
      this.options.different_eyes_color = false;
    }
    if (!this.options.marker_in_color) {
      this.options.marker_in_color = "#000000";
    }
    if (!this.options.marker_top_right_center) {
      this.options.marker_top_right_center =
        this.options.marker_in_color || "#000000";
    }
    if (!this.options.marker_in_color) {
      this.options.marker_in_color = this.options.marker_in_color || "#000000";
    }
    if (!this.options.marker_bottom_left_center) {
      this.options.marker_bottom_left_center =
        this.options.marker_in_color || "#000000";
    }

    // Ensure synchronization
    if (!this.options.different_eyes_color) {
      this.options.marker_top_right_center = this.options.marker_in_color;
      this.options.marker_in_color = this.options.marker_in_color;
      this.options.marker_bottom_left_center = this.options.marker_in_color;
    }

    // Set initial selected design
    if (this.options.cornersDotOptions && this.options.cornersDotOptions.type) {
      this.selectedDesign = this.options.cornersDotOptions.type;
    }
  },

  computed: {
    options: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    // computedRotation: { // Disabled - eyes only support single colors
    //   get() {
    //     return this.rotation;
    //   },
    //   set(val) {
    //     this.rotation = val;
    //     this.options.cornersDotOptions.gradient.rotation =
    //       (val * Math.PI) / 180;
    //     this.$emit("update", true);
    //   },
    // },
  },

  watch: {
    //cornersSquareOptions
    "options.cornersDotOptions.color": {
      handler(newVal) {
        if (!this.options.different_eyes_color && newVal) {
          this.options.marker_top_right_center = newVal;
          this.options.marker_in_color = newVal;
          this.options.marker_bottom_left_center = newVal;
        }
      },
      immediate: true,
    },
    // Sync individual colors when single color changes
    "options.marker_in_color": {
      handler(newVal) {
        if (!this.options.different_eyes_color && newVal) {
          // Update all individual colors when in single mode
          this.options.marker_top_right_center = newVal;
          this.options.marker_in_color = newVal;
          this.options.marker_bottom_left_center = newVal;
        }
      },
      immediate: false,
    },
  },

  methods: {
    chooseDesign(value) {
      this.selectedDesign = value;
      this.options.cornersDotOptions.type = value;
      this.$emit("update", true); // Force update
    },
    handleDifferentEyesChange() {
      if (this.options.different_eyes_color) {
        // Initialize individual eye colors if they don't exist
        const defaultCenterColor =
          this.options.cornersDotOptions.color || "#000000";

        this.options.marker_top_right_center =
          this.options.marker_top_right_center || defaultCenterColor;
        this.options.marker_in_color =
          this.options.marker_in_color || defaultCenterColor;
        this.options.marker_bottom_left_center =
          this.options.marker_bottom_left_center || defaultCenterColor;
      } else {
        // When switching back to single eye color, use the first individual color as the base
        // Set all individual colors to the same value
        const finalColor = this.options.cornersDotOptions.color || "#000000";

        this.options.cornersDotOptions.color = finalColor;
        this.options.marker_top_right_center = finalColor;
        this.options.marker_in_color = finalColor;
        this.options.marker_bottom_left_center = finalColor;
      }
      this.$emit("update", true);
    },
  },
};
</script>

<style scoped>
/* Marker color section styling */
.marker-color-section {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
  transition: all 0.3s ease;
}

.marker-color-section:hover {
  border-color: #bb86fc;
  box-shadow: 0 2px 8px rgba(187, 134, 252, 0.1);
}

.marker-corner-title {
  font-weight: 500;
  color: #424242;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.marker-color-picker {
  margin-bottom: 8px;
}

/* Icon styling */
.marker-corner-title .v-icon {
  opacity: 0.8;
}

.marker-corner-title .v-icon--color-info {
  color: #2196f3 !important;
}

/* Pattern styling */
.pattern:hover {
  border: 1px solid #413199;
  border-radius: 6px;
  background-color: #413199;
  box-shadow: 0 -8px 6px rgba(25, 25, 26, 0.2),
    0px 8px 6px rgba(25, 25, 26, 0.2);
}

.pattern.selected {
  border: 1px solid #001554;
  border-radius: 6px;
  background-color: #001554;
  box-shadow: 0 10px 15px #00155423, 0px -10px 15px #00155423;
}

.filterwhite {
  filter: brightness(0) invert(1);
}
</style>
